import {AxiosInstance, AxiosError} from 'axios';
import {CustomException} from '@core/modules/common/infra/error';
import {httpMessage} from '@core/modules/common/infra/message';

import {Paths} from './keys';
import { ValidateCataGadpGateway } from '../domain/validateCataGadp.gateway';
import { ValidateCataGadpInterface, ValidateCataGadpBatchResponse, ServiceInfoResponse } from '../domain/validateCataGadp.entities';

export class ValidateCataGadpHttpGateway implements ValidateCataGadpGateway {
    constructor(private http: AxiosInstance) {}

    async verify(params: ValidateCataGadpInterface): Promise<number> {
        let attemp = 0;
        const maxAttempts = 2;
        let res: any;
        while (attemp < maxAttempts) {
            try {
                res = await this.http.post(Paths.default, { schedule_id: params });
                if (!res?.data) {
                    return res?.data
                }
                // Garantir que o valor retornado seja tratado como número
                const bplId = res?.data?.bplidassignedToInvoice;
                return typeof bplId === 'string' ? parseInt(bplId, 10) : bplId;
            } catch (err) {
                const error = err as AxiosError;
                if (error?.response?.status === 409) {
                    throw new CustomException(httpMessage.updateError('create invoice'));
                }
                attemp++;
                if (attemp >= maxAttempts) {
                    return 0;
                }
            }   
    }
    return 0 
}

    async verifyBatch(scheduleIds: number[]): Promise<ValidateCataGadpBatchResponse> {
        try {
            const res = await this.http.post(Paths.batch, { schedules: scheduleIds }, {
                timeout: 120000
            });
            return res?.data || { bplidassignedToInvoice: [] };
        } catch (err) {
            const error = err as AxiosError;
            if (error?.response?.status === 409) {
                throw new CustomException(httpMessage.updateError('create invoice'));
            }
            return { bplidassignedToInvoice: [] };
        }
    }

    async getServiceInfo(bplId: number): Promise<ServiceInfoResponse | null> {
        try {
            const res = await this.http.get(`${Paths.serviceInfo}/${bplId}`);
            return res?.data ?? null;
        } catch {
            return null;
        }
    }
}